import { render } from "./ToastSuccessIcon.vue?vue&type=template&id=68ca6169"
import script from "./ToastSuccessIcon.vue?vue&type=script&lang=js"
export * from "./ToastSuccessIcon.vue?vue&type=script&lang=js"

import exportComponent from "C:\\OpenServer\\domains\\front-studixy.dm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__